var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage134(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.933,
    height: 29.933,
    viewBox: "0 0 29.933 29.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M29.688,4.993H25.946V2.748a.748.748,0,1,0-1.5,0V4.993H9.483V2.748a.748.748,0,0,0-1.5,0V4.993H4.245A2.245,2.245,0,0,0,2,7.238V29.688a2.245,2.245,0,0,0,2.245,2.245H29.688a2.245,2.245,0,0,0,2.245-2.245V7.238A2.245,2.245,0,0,0,29.688,4.993Zm.748,24.694a.748.748,0,0,1-.748.748H4.245a.748.748,0,0,1-.748-.748V7.238a.748.748,0,0,1,.748-.748H7.987v.748a.748.748,0,1,0,1.5,0V6.49H24.449v.748a.748.748,0,1,0,1.5,0V6.49h3.742a.748.748,0,0,1,.748.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M10.238,8H5.748A.748.748,0,0,0,5,8.748v4.49a.748.748,0,0,0,.748.748h4.49a.748.748,0,0,0,.748-.748V8.748A.748.748,0,0,0,10.238,8ZM9.49,12.49H6.5V9.5H9.49Z",
    transform: "translate(1.49 2.98)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M20.238,8h-4.49A.748.748,0,0,0,15,8.748v4.49a.748.748,0,0,0,.748.748h4.49a.748.748,0,0,0,.748-.748V8.748A.748.748,0,0,0,20.238,8Zm-.748,4.49H16.5V9.5H19.49Z",
    transform: "translate(6.456 2.98)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M15.238,8h-4.49A.748.748,0,0,0,10,8.748v4.49a.748.748,0,0,0,.748.748h4.49a.748.748,0,0,0,.748-.748V8.748A.748.748,0,0,0,15.238,8Zm-.748,4.49H11.5V9.5H14.49Z",
    transform: "translate(3.973 2.98)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M10.238,15H5.748A.748.748,0,0,0,5,15.748v4.49a.748.748,0,0,0,.748.748h4.49a.748.748,0,0,0,.748-.748v-4.49A.748.748,0,0,0,10.238,15ZM9.49,19.49H6.5V16.5H9.49Z",
    transform: "translate(1.49 6.456)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M20.238,15h-4.49a.748.748,0,0,0-.748.748v4.49a.748.748,0,0,0,.748.748h4.49a.748.748,0,0,0,.748-.748v-4.49A.748.748,0,0,0,20.238,15Zm-.748,4.49H16.5V16.5H19.49Z",
    transform: "translate(6.456 6.456)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M15.238,15h-4.49a.748.748,0,0,0-.748.748v4.49a.748.748,0,0,0,.748.748h4.49a.748.748,0,0,0,.748-.748v-4.49A.748.748,0,0,0,15.238,15Zm-.748,4.49H11.5V16.5H14.49Z",
    transform: "translate(3.973 6.456)",
    fill: "#f45000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage134);
export default __webpack_public_path__ + "static/media/Image-134.b60fd9ba8f61345c7c3dceafe87a58a5.svg";
export { ForwardRef as ReactComponent };